import { z } from "zod"
import axios, { AxiosRequestHeaders } from "axios"

export const NEWSLETTERPURPOSES = z.enum(["WAITING_LIST", "NEWSLETTER"])
export const NEWSLETTERINTERESTED = z.enum(["PATIENT", "HEALTHCARE_PROFESIONAL", "INSURANCE", "OTHER"])
export const header = {
  "Content-Type": "application/json",
} as AxiosRequestHeaders

export interface postNewsletterSubscriptionParameters {
  email: string
  name: string
  purposes: z.infer<typeof NEWSLETTERPURPOSES>[]
  type: z.infer<typeof NEWSLETTERINTERESTED>
  btype: string | null
}

export interface postNewsletterConfirmParameters {
  token: string
  btype: string | null
}

export const postNewsletterSubscription = async (values: postNewsletterSubscriptionParameters) => {
  const url = `${process.env.NEXT_PUBLIC_SUBSCRIPTION_URL}request-subscription`

  return axios.post(url, values, {
    timeout: 15000,
    timeoutErrorMessage: "Timeout",
    headers: header,
    withCredentials: true,
  })
}
export const postNewsletterConfirm = async (values: postNewsletterConfirmParameters) => {
  const url = `${process.env.NEXT_PUBLIC_SUBSCRIPTION_URL}confirm-subscription`

  return axios.post(url, values, {
    timeout: 15000,
    timeoutErrorMessage: "Timeout",
    headers: header,
    withCredentials: true,
  })
}
